module.exports = __webpack_public_path__ + "static/media/Shiriel Abramson.8c7523fb.JPG";